import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams, generatePath } from "react-router-dom";
import { Box, IconButton } from "@mui/material";
import useGetClientId from "../hooks/useGetClientId";

import Footer from "./Footer";
import BottomBarIcons from "./BottomBarIcons";
import {
  DELETE_USER_CLIENT,
  GET_CLINET_ID_API,
  USERS_BY_CLIENT,
} from "../api/apiPath";
import http from "../api/server";
import { hostName } from "../config/config";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Toaster from "./common/Toaster";
import UpdateUser from "./UpdateUser";
import ConfirmationPopup from "./common/ConfirmationPopup";
import DynamicTable from "./common/DynamicTable";
import LoadingComponent from "./common/LoadingComponent";
import DynamicTiles from "../components/common/DynamicTiles.js";
import SidebarIcons from "./SidebarIcons";
import ClearIcon from "@mui/icons-material/Clear";
import searchIcon from "../assets/img/searchIcon.png";

import activeEditIcon from "../assets/img/activeEditIcon.png";
import activeDeleteIcon from "../assets/img/aciveDeleteIcon.png";


export default function Members() {
  const { clientNameParam } = useParams();
  const [users, setUsers] = useState([]);
  const [ActiveUsers, setActiveUsers] = useState([]);
  const [ArchivedUsers, setArchivedUsers] = useState([]);

  const [hideSidebar, setHideSidebar] = useState(false);

  const { userObj } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const clientObj = useGetClientId();
  const [multiUserSelected, setMultiUserSelected] = useState(null);
  // const [showUpdateUserModal, setShowUpdateUserModal] = useState(false);
  const [loading, setLoading] = useState(true);

  // delete modal states
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [showActiveMembers, setShowActiveMembers] = useState(true);

  const [toolbar, setToolBar] = useState({
    searchText: "",
    name: "Name",
    city: "City",
    role: "Role",
    userType: "User Type",
    email: "Email",
    userStatus: "Active Members",
  });

  const filteredRows = users?.filter((row) => {
    const matchesSearch =
      !toolbar.searchText ||
      row.fullName?.toLowerCase().includes(toolbar.searchText.toLowerCase()) ||
      row.cityName?.toLowerCase().includes(toolbar.searchText.toLowerCase()) ||
      row.roleName?.toLowerCase().includes(toolbar.searchText.toLowerCase()) ||
      row.phoneNumber
        ?.toLowerCase()
        .includes(toolbar.searchText.toLowerCase()) ||
      row.roleName?.toLowerCase().includes(toolbar.searchText.toLowerCase()) ||
      row.userType?.toLowerCase().includes(toolbar.searchText.toLowerCase()) ||
      row.userEmail?.toLowerCase().includes(toolbar.searchText.toLowerCase()); // ||

    const matchesName =
      toolbar.name === "Name" || row.fullName === toolbar.name;

    const matchesEmail =
      toolbar.email === "Email" || row.userEmail === toolbar.email;

    const matchesCity =
      toolbar.city === "City" || row.cityName === toolbar.city;

    const matchesRole =
      toolbar.role === "Role" || row.roleName === toolbar.role;

    const matchesUserType =
      toolbar.userType === "User Type" || row.userType === toolbar.userType;

    return (
      matchesSearch &&
      matchesName &&
      matchesEmail &&
      matchesCity &&
      matchesRole &&
      matchesUserType
    );
  })
 .sort((a, b) => Number(b.userId) - Number(a.userId));

  const fetchData = async (userObj) => {
    setLoading(true);
    try {
      const responseClient = await http.get(
        GET_CLINET_ID_API + "/" + userObj?.userId
      );

      const response = await http.get(
        USERS_BY_CLIENT + "clientId=" + responseClient?.data?.clientId
      );

      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.message}`);
      }
      const result = await response?.data;
      result.forEach((item) => {
        item.id = item.userId; // Assigning a sequential ID
      });
      const resultWithoutLoggeduser = result.filter(x => x.userEmail.toLowerCase() !== userObj.userEmail.toLowerCase());
      const activeResults = resultWithoutLoggeduser.filter(x => x.active === true && x.userStatus.toLowerCase() === "active")
      setUsers(activeResults);
      setActiveUsers(activeResults);
      const archivedResults = resultWithoutLoggeduser.filter(x => x.active === false || x.userStatus.toLowerCase() === "archived")
      setArchivedUsers(archivedResults);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userObj) {
      fetchData(userObj);
    }
  }, [userObj]);

  useEffect(() => {
    if (showActiveMembers) {
      setUsers(ActiveUsers);
    } else {
      setUsers(ArchivedUsers);
    }
  }, [showActiveMembers]);

  const deleteMultipleUser = async () => {
    const itemsWithQuantity = users?.filter((objA) =>
      multiUserSelected.some((objB) => objB === objA.id)
    );
    const getUserMapping = itemsWithQuantity?.map((data) => ({
      userId: data.userId,
      propertyMasterId: data.propertyId,
      roleId: data.roleId,
    }));
    const payloadForMultipleUserDelete = {
      clientId: clientObj?.clientId,
      userMappings: getUserMapping,
      modifiedBy: userObj.userEmail,
    };
    try {
      const response = await fetch(hostName + DELETE_USER_CLIENT, {
        method: "DELETE",
        body: JSON.stringify(payloadForMultipleUserDelete),
        headers: {
          Authorization: "Bearer " + userObj?.token,
          "Content-Type": "application/json",
        },
      });
      if (response?.status === 401) {
        window.location.href =  generatePath("/client/:clientNameParam/", {
                            clientNameParam,
                          });
      }
      if (response.status === 200) {
        fetchData(userObj);
      }
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleMultipleUserDelete = async (selectedUsers) => {
    setMultiUserSelected(selectedUsers);
    setShowDeleteModal(true);
  };

  const handleSingleUserDelete = async (userID, propertyId, roleId) => {
    const payload = {
      clientId: clientObj?.clientId,
      userMappings: [
        {
          userId: userID,
          propertyMasterId: propertyId,
          roleId: roleId,
        },
      ],
      modifiedBy: userObj?.userEmail,
    };
    try {
      const response = await fetch(hostName + DELETE_USER_CLIENT, {
        method: "DELETE",
        body: JSON.stringify(payload),
        headers: {
          Authorization: "Bearer " + userObj?.token,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        fetchData(userObj);
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "User deleted successfully.",
          });
        }, 2000);
      }else{
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Could not delete the user. Please try again.",
          });
        }, 2000);
      }
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.log(error);
      setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Could not delete the user. Please try again.",
          });
        }, 2000);
    }
  };

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };
  const [editMember, setEditMember] = useState(null);
  const [showEditMember, setShowEditMember] = useState(false);
  const handleEditProperty = (id) => {
    const editPropertyDetails = users?.filter((data) => {
      return data.userId === id;
    });
    setEditMember(editPropertyDetails);
    setShowEditMember(true);
  };
  useEffect(() => {
    fetchData(userObj);
    setShowActiveMembers(true);
  }, [editMember, showEditMember]);

  const tableColumns = [
    {
      field: "fullName",
      height: 50,
      minWidth: 190,
      headerName: "Name",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      flex: 1,
      type: "string",
    },
    {
      field: "userEmail",
      headerName: "Email",
      width: 230,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 230,
      flex: 1,
    },
    {
      field: "phoneNumber",
      headerName: "Contact No",
      width: 150,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "roleName",
      headerName: "Role",
      width: 150,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "cityName",
      headerName: "City",
      width: 160,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "userType",
      width: 160,
      height: 50,
      headerName: "User Type",
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "userStatus",
      width: 120,
      height: 50,
      headerName: "User Status",
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 120,
      flex: 1,
      renderCell: (params) => {
        const status = params.value;
        if (!status) return "";
        return status.charAt(0).toUpperCase() + status.slice(1);
        
      },
    },
    {
      field: "Actions",
      headerName: "Actions",
      width: 90,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      type: "string",
      minWidth: 90,
      flex: 1,
      renderCell: (data) => (
        <Box>
          <img
            tabIndex={0}
            title="Edit Member"
            alt="Edit Member"
            onClick={() => {
              handleEditProperty(data?.row?.id);
            }}
            src={activeEditIcon}
            style={{cursor: "pointer"}}
          >
          </img>

         {showActiveMembers && <img
            tabIndex={0}
            title="Delete Member"
            alt="Delete Member"
            onClick={() => {
              setShowDeleteModal(true);
              setUserToDelete({
                userId: data?.row?.userId,
                propertyId: data?.row?.propertyId,
                roleId: data?.row?.roleId,
              });
            }}
            src={activeDeleteIcon}
            style={{cursor: "pointer"}}

          >
          </img>}
        </Box>
      ),
    },
    // {
    //   field: "edit",
    //   width: 230,
    //   height: 50,
    //   headerName: "Edit",
    //   headerClassName: "super-app-theme--header",
    //   editable: false,
    //   minWidth: 180,
    //   flex: 1,
    //   type: "string",
    //   renderCell: (data) => {
    //     return (
    //       <>
    //         <i
    //           className="fa-solid fa-pen-to-square fa-lg"
    //           title="Edit"
    //           style={{ cursor: "pointer", justifyItems: "center" }}
    //           onClick={() => {
    //             handleEditProperty(data?.row?.id - 1);
    //           }}
    //         ></i>
    //       </>
    //     );
    //   },
    // },
    // {
    //   field: "delete",
    //   width: 230,
    //   height: 50,
    //   headerName: "Delete",
    //   headerClassName: "super-app-theme--header",
    //   editable: false,
    //   minWidth: 180,
    //   flex: 1,
    //   type: "string",
    //   renderCell: (data) => {
    //     return (
    //       <>
    //         <i
    //           className="fa fa-trash text-danger"
    //           title="Delete"
    //           style={{ cursor: "pointer", justifyItems: "center" }}
    //           onClick={() => {
    //             setShowDeleteModal(true);
    //             setUserToDelete({
    //               userId: data?.row?.userId,
    //               propertyId: data?.row?.propertyId,
    //               roleId: data?.row?.roleId,
    //             });
    //           }}
    //         ></i>
    //       </>
    //     );
    //   },
    // },
  ];

  const isAnyFilterApplied =
    toolbar.searchText !== "" ||
    toolbar.name !== "Name" ||
    toolbar.email !== "Email" ||
    toolbar.city !== "City" ||
    toolbar.role !== "Role" ||
    toolbar.userType !== "User Type";

  return (
    <>
      <div>
        <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      </div>
      {userObj && (
        <div className="dashboard_body_main vh-100">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
           <SidebarIcons 
             setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
              />
          )}

          {showEditMember ? (
            <UpdateUser
              entriesData={editMember}
              setShowEditMember={setShowEditMember}
            />
          ) : (
            <div className=" dashboard_body  py-0 w-100">
              <div className="col-sm-12 d-flex justify-content-between m-0 mt-3 align-items-end mt-3">
                <div className="text-start">
                  <p className="fs-3 fw-bold m-0">Users</p>
                  <p className="fs-6 m-0">Manage and track all users.</p>
                </div>
                <div className="col-auto ms-auto">
                  <button
                    type="button"
                    className="btn btn-primary custom_toolbar_btn mx-2"
                    onClick={() => navigate(
                      generatePath("/client/:clientNameParam/inviteNewMember", {
                        clientNameParam,
                      })
                    )}
                  >
                    <i className="fa fa-add me-2"></i>Invite New Users
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary custom_toolbar_btn"
                    onClick={() => setShowActiveMembers(!showActiveMembers)}
                  >
                    <i className="fa fa-eye me-2"></i>{showActiveMembers ? "View Archived Users" : "View Active Users"}
                  </button>
                </div>
              </div>

              <div className="row py-3 align-items-center g-2">
                {/* Search Bar */}
                <div className="custom_toolbar_search col-6 col-md-2 ">
                  <img src={searchIcon} />
                  <input
                    type="text"
                    className="form-control custom_toolbar_control"
                    id="floatingInput"
                    placeholder="Search"
                    value={toolbar.searchText}
                    onChange={(e) =>
                      setToolBar({ ...toolbar, searchText: e.target.value })
                    }
                  />
                </div>

                {/* Dropdowns */}
                <div className="col-6 col-md-2">
                  <select
                    className="form-select custom_toolbar_control"
                    value={toolbar.name}
                    onChange={(e) =>
                      setToolBar({ ...toolbar, name: e.target.value })
                    }
                  >
                    <option value="Name">Name</option>
                    {[...new Set(users?.map((user) => user.fullName).filter(Boolean))]
                       .sort((a, b) => (a || "").localeCompare(b || ""))
                    .map(
                      (cityItem, index) => (
                        <option key={index} value={cityItem}>
                          {cityItem}
                        </option>
                      )
                    )}
                  </select>
                </div>

                {/* <div className="col-6 col-md-2">
                  <select
                    className="form-select custom_toolbar_control"
                    value={toolbar.email}
                    onChange={(e) =>
                      setToolBar({ ...toolbar, email: e.target.value })
                    }
                  >
                    <option value="Email">Email</option>
                    {[...new Set(users?.map((user) => user.userEmail))].map(
                      (cityItem, index) => (
                        <option key={index} value={cityItem}>
                          {cityItem}
                        </option>
                      )
                    )}
                  </select>
                </div> */}

                <div className="col-6 col-md-2">
                  <select
                    className="form-select custom_toolbar_control"
                    value={toolbar.city}
                    onChange={(e) =>
                      setToolBar({ ...toolbar, city: e.target.value })
                    }
                  >
                    <option value="City">City</option>
                    {[...new Set(users?.map((user) => user.cityName).filter(Boolean))]
                       .sort((a, b) => (a || "").localeCompare(b || ""))
                    .map(
                      (cityItem, index) => (
                        <option key={index} value={cityItem}>
                          {cityItem}
                        </option>
                      )
                    )}
                  </select>
                </div>
                <div className="col-6 col-md-2">
                  <select
                    className="form-select custom_toolbar_control"
                    value={toolbar.role}
                    onChange={(e) =>
                      setToolBar({ ...toolbar, role: e.target.value })
                    }
                  >
                    <option value="Role">Role</option>
                    {[...new Set(users?.map((user) => user.roleName).filter(Boolean))]
                     .sort((a, b) => (a || "").localeCompare(b || ""))
                    .map(
                      (cityItem, index) => (
                        <option key={index} value={cityItem}>
                          {cityItem}
                        </option>
                      )
                    )}
                  </select>
                </div>
                <div className="col-6 col-md-2">
                  <select
                    className="form-select custom_toolbar_control"
                    value={toolbar.userType}
                    onChange={(e) =>
                      setToolBar({ ...toolbar, userType: e.target.value })
                    }
                  >
                    <option value="User Type">User Type</option>
                    {[...new Set(users?.map((user) => user.userType).filter(Boolean))]
                     .sort((a, b) => (a || "").localeCompare(b || ""))
                    .map(
                      (cityItem, index) => (
                        <option key={index} value={cityItem}>
                          {cityItem}
                        </option>
                      )
                    )}
                  </select>
                </div>
                {isAnyFilterApplied && (
                  <div style={{ width: "auto", paddingLeft: "0px" }}>
                    <IconButton
                      tabIndex={0}
                      title="Clear Filters"
                      onClick={() => {
                        setToolBar({
                          searchText: "",
                          name: "Name",
                          city: "City",
                          role: "Role",
                          userType: "User Type",
                          email: "Email",
                        });
                      }}
                    >
                      <ClearIcon sx={{ color: "#717186" }} fontSize="small" />
                    </IconButton>
                  </div>
                )}
                
                {/* Export Button */}
                {/* <div className="col-auto ms-auto">
                  <button
                    type="button"
                    className="btn btn-primary custom_toolbar_btn"
                    onClick={() => navigate(
                      generatePath("/client/:clientNameParam/inviteNewMember", {
                        clientNameParam,
                      })
                    )}
                  >
                    <i className="fa fa-add me-2"></i>Invite New Member
                  </button>
                </div> */}
              </div>

              <div
                className="inspection-table"
                style={{ width: "100%", paddingTop: "10px" }}
              >
                <DynamicTable
                  tableData={filteredRows}
                  columnsValue={tableColumns}
                  showSelectAll={false}
                      minRowHeight={45}

                  handleCheckBoxSelection={handleMultipleUserDelete}
                  pageSize={10}
                  pageSizeOptions={[100, 150, 200, { value: -1, label: "All" }]}
                />
              </div>
              <div className="inspection-tile">
                {filteredRows &&
                  filteredRows?.map((item) => {
                    return (
                      // eslint-disable-next-line react/jsx-key
                      <DynamicTiles
                        tableData={item}
                        module="memberDashboard"
                        handleEditProperty={handleEditProperty}
                        setUserToDelete={setUserToDelete}
                        setShowDeleteModal={setShowDeleteModal}
                      />
                    );
                  })}
              </div>
            </div>
          )}

          <Footer />
          <div className="bottom-bar-spacing"></div>
          <BottomBarIcons />
          <Toaster
            show={toastData.toastShow}
            toastType={toastData.toastType}
            title={toastData.toastString}
            theme={"dark"}
            position="top-center"
            closeButton={closeButton}
          />

          {/* {showUpdateUserModal && (
            <UpdateUser
              entriesData={editMember}
              setShowUpdateUserModal={setShowUpdateUserModal}
            />
          )} */}
        </div>
      )}
      <LoadingComponent loading={loading} />

      {showDeleteModal && (
        <ConfirmationPopup
          show={showDeleteModal}
          headingText="Confirm Delete"
          infoText="Are you sure you want to delete this member? Please ensure that the user is not part of any active inspections from the Inspection Dashboard before proceeding with the deletion."
          cancelText="Cancel"
          submitText="Yes, Delete"
          onCancel={() => {
            setShowDeleteModal(false);
            setUserToDelete(null);
            setMultiUserSelected(null);
          }}
          onSubmit={() => {
            if (multiUserSelected) {
              deleteMultipleUser();
            }
            if (userToDelete) {
              handleSingleUserDelete(
                userToDelete.userId,
                userToDelete.propertyId,
                userToDelete.roleId
              );
            }
            setShowDeleteModal(false);
          }}
        />
      )}
    </>
  );
}
